// test1881
(1881 && 0);
